import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Alert from './ui/Alert';
import Button from './ui/Button';
import Card from './ui/Card';
import TextField from './ui/TextField';
import { supabase } from './supabaseClient';

function LoginPage({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleDemoLogin = () => {
    setError('');
    if (typeof onLoginSuccess === 'function') onLoginSuccess();
    navigate('/products');
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    setError('');

    // Preferred: Supabase Auth (email/password)
    if (supabase) {
      const email = username.trim();
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (signInError) {
        const raw = (signInError.message || '').toLowerCase();
        if (raw.includes('email not confirmed')) {
          setError('E-mailadres is nog niet bevestigd in Supabase. Zet in Supabase bij de gebruiker “Email confirmed” aan, of schakel email-confirmation uit.');
        } else if (raw.includes('invalid login credentials')) {
          setError('Ongeldige inloggegevens (controleer e-mail + wachtwoord).');
        } else if (raw.includes('failed to fetch') || raw.includes('fetch')) {
          setError('Kan geen verbinding maken met Supabase. Controleer of REACT_APP_SUPABASE_URL en REACT_APP_SUPABASE_ANON_KEY goed staan in Vercel.');
        } else {
          setError(`Inloggen mislukt: ${signInError.message}`);
        }
        return;
      }

      if (typeof onLoginSuccess === 'function') onLoginSuccess();
      navigate('/products');
      return;
    }

    // Fallback: simpele mock login (alleen wanneer Supabase niet is ingesteld)
    if (username === 'medewerker' && password === 'premtech') {
      if (typeof onLoginSuccess === 'function') onLoginSuccess();
      navigate('/products');
    } else {
      setError('Ongeldige inloggegevens');
    }
  };

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <Card className="pageCard" style={{ width: 'min(560px, 100%)' }}>
        <div style={{ marginBottom: 18 }}>
          <h1 style={{ margin: 0, color: 'var(--text0)', letterSpacing: '-0.4px' }}>
            Inloggen
          </h1>
          <div className="muted" style={{ marginTop: 8 }}>
            Gebruik je account{supabase ? '' : ' of kies “Demo login”'}.
          </div>
        </div>

        {error ? (
          <Alert tone="danger" title="Inloggen mislukt" style={{ marginBottom: 14 }}>
            {error}
          </Alert>
        ) : null}

        <form onSubmit={handleLogin} style={{ display: 'grid', gap: 14 }}>
          <TextField
            label={supabase ? 'E-mail' : 'Gebruikersnaam'}
            type="text"
            autoComplete={supabase ? 'email' : 'username'}
            placeholder={supabase ? 'bijv. sales@premtech.nl' : 'bijv. medewerker'}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            name="username"
            id="username"
          />
          <TextField
            label="Wachtwoord"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            name="password"
            id="password"
          />

          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 6 }}>
            <Button type="submit" variant="primary">
              Inloggen
            </Button>
            {!supabase ? (
              <Button type="button" variant="ghost" onClick={handleDemoLogin}>
                Demo login
              </Button>
            ) : null}
          </div>

          {!supabase ? (
            <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
              Demo login slaat geen gegevens op.
            </div>
          ) : null}
        </form>
      </Card>
    </div>
  );
}

export default LoginPage;
